import { render, staticRenderFns } from "./PlansList.vue?vue&type=template&id=467b9828&scoped=true&"
import script from "./PlansList.vue?vue&type=script&lang=js&"
export * from "./PlansList.vue?vue&type=script&lang=js&"
import style0 from "./PlansList.vue?vue&type=style&index=0&id=467b9828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467b9828",
  null
  
)

export default component.exports